export default __webpack_public_path__ + "static/media/DealerMethodsPhone.png.webp";